import * as THREE from 'three';
import type { IfcGeoref } from '@gis/landxml';

/**
 * IfcMapConversion in the 3D scene (2D-map IFC spec §2.2): T(E,N,H)·Rz(θ)·S(sx,sy,sz)
 * — the same map as scripts/ifc_georef.py::apply_georef_xyz, pinned by
 * scripts/test_fixtures/ifc/georef_cases.json.
 */
export function georefMatrix(g: IfcGeoref): THREE.Matrix4 {
  return new THREE.Matrix4().compose(
    new THREE.Vector3(g.eastings, g.northings, g.height),
    new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 0, 1), g.rotationRad),
    new THREE.Vector3(g.scaleX, g.scaleY, g.scaleZ),
  );
}

export function applyGeorefToGroup(group: THREE.Group, g: IfcGeoref | null | undefined): void {
  if (!g) {
    group.position.set(0, 0, 0);
    group.rotation.set(0, 0, 0);
    group.scale.set(1, 1, 1);
  } else {
    group.position.set(g.eastings, g.northings, g.height);
    group.rotation.set(0, 0, g.rotationRad);
    group.scale.set(g.scaleX, g.scaleY, g.scaleZ);
  }
  group.updateMatrix();
}

export { georefOf } from '@gis/landxml';
